import React from "react";

export const PharmacySecondaryBenefits = ({ biInfo }) => {
  return (
    <>
      <li
        className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
        id={`product-secondary-benefits-remaining-cost-of-care-after-primary-benefits-applied`}
      >
        <h5 className="text-muted fw-semibold">Remaining Cost After Primary Benefits Applied</h5>
        <h5 className="text-dark fw-bold">{biInfo.remaining_patient_responsibility_cents}</h5>
      </li>
      <li
        className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
        id={`product-secondary-benefits-secondary-coinsurance`}
      >
        <h5 className="text-muted fw-semibold">Secondary Coinsurance</h5>
        <h5 className="text-dark fw-bold">{biInfo.coinsurance}</h5>
      </li>
      <li
        className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
        id={`product-secondary-benefits-secondary-deductible`}
      >
        <h5 className="text-muted fw-semibold">Secondary Deductible</h5>
        <h5 className="text-dark fw-bold">{biInfo.remaining_deductible_cents}</h5>
      </li>
      <li
        className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
        id={`product-secondary-benefits-secondary-max-out-of-pocket`}
      >
        <h5 className="text-muted fw-semibold">Secondary Max Out of Pocket</h5>
        <h5 className="text-dark fw-bold">{biInfo.remaining_moop_cents}</h5>
      </li>
      <li
        className="d-flex flex-row justify-content-between align-items-center mb-2 mx-2"
        id={`product-secondary-benefits-secondary-estimated-patient-responsibility`}
      >
        <h5 className="text-muted fw-semibold">Secondary Estimated Patient Responsibility</h5>
        <h5 className="text-dark fw-bold">{biInfo.estimated_out_of_pocket_cents}</h5>
      </li>
    </>
  );
};
